import * as React from 'react';
import { BookOpen } from 'lucide-react';
import { FeaturedRecipe } from '../../types/landing';
import { Slider } from './Slider';
import { RecipeCard } from './RecipeCard';

interface FeaturedRecipesSliderProps {
  recipes: FeaturedRecipe[];
}

export function FeaturedRecipesSlider({ recipes }: FeaturedRecipesSliderProps): React.ReactElement {
  return (
    <div className="featured-recipes-wrapper">
      <style>{`
        .featured-recipes-wrapper {
          background: #fffaf0;
        }

        .featured-recipes-wrapper .slider-section {
          background: transparent;
        }
      `}</style>

      <Slider
        title="Recetas destacadas"
        shortTitle="Recetas"
        icon={<BookOpen size={24} />}
      >
        {recipes.map(recipe => (
          <RecipeCard key={recipe.id} recipe={recipe} />
        ))}
      </Slider>
    </div>
  );
}
